import PropTypes from 'prop-types';
import { Fragment, useContext, useEffect, useState } from 'react';
import AuthContext from '../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { checkPermission } from '../helpers/checker';
import { appLogo, appName, appShortName, hex2rgb, translate } from '../helpers/frontend';
import { unescape } from 'html-escaper';

import TopnavRealTime from './TopnavRealTime';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

import { connect, useDispatch } from 'react-redux';
import { processList as feProcessList } from '../actions/frontend.actions';
import { processList as smProcessList } from '../actions/sales-manager.actions';
import { APP_THEME, APP_USE_CURRENCY } from '../actions/types';
import { userRead, userSignout, userUpdate } from '../actions/user.actions';
import { DEV_MODE, DEV_PROCESS, SYSTEM_LANGUAGES } from '../actions/variables';
import { CurrencyModel, UserPreferenceModel } from '../models';

import { Swiper, SwiperSlide } from 'swiper/react';
import { getFirebaseDB } from '../helpers/firebase';

function Topnav(props) {
  const {
    user, isSignedIn, permissions, onSignout,
    partnerShops, externalShop, shopCode, prefix, sellerShopBrands,
    settings, lang, langObj, onLanguageUpdate,
  } = useContext(AuthContext);
  const dispatch = useDispatch();

  const location = useLocation();
	const [currentPath, setCurrentPath] = useState('/');
  const [isReady, setIsReady] = useState(false);

  
  // START: Menu
	const [menu, setMenu] = useState([]);
	const [menuToggle, setMenuToggle] = useState([]);
  const onMenuToggle = (e, i) => {
    e?.preventDefault();
    let temp = [...menuToggle];
    temp[i] = !temp[i];
    setMenuToggle(temp);
  };
  
	const [sidenavActive, setSidenavActive] = useState(false);
  const onSidenavActiveToggle = (e) => {
    e?.preventDefault();
    setSidenavActive(!sidenavActive);
  };
  // END: Menu


  // START: Currency
  const onCurrencyLoad = async () => {
    if(isSignedIn){
      const _pref = await props.userRead('preference', { preference: 'Currency' });
      dispatch({ type: APP_USE_CURRENCY, payload: _pref.value });
    }
  };
  const onCurrencyChange = async (e, d) => {
    e?.preventDefault();
    if(isSignedIn){
      const _currency = new CurrencyModel(d);
      await props.userUpdate('preference', 
        { preference: 'Currency', value: { _id: _currency._id } }, true);
      dispatch({ type: APP_USE_CURRENCY, payload: _currency });
    }
  };
  // END: Currency


  // START: Language
  const processLanguageUpdate = (e, _lang) => {
    e?.preventDefault();
    if(_lang && _lang !== lang) onLanguageUpdate(_lang, true);
  };
  // END: Language
  

  // START: Theme
  const [inTheme, setInTheme] = useState(false);
  const [useTheme, setUseTheme] = useState(false);
  const [theme, setTheme] = useState(new UserPreferenceModel({ preference: 'Theme' }));
  const [themeProcess, setThemeProcess] = useState(false);
  const onThemeLoad = async (newLoad=false) => {
    if(settings['APP_ENABLE_THEME'] === '1'){
      let _pref = new UserPreferenceModel({ preference: 'Theme' });
      if(inTheme && (!_pref.isValid() || newLoad)){
        _pref = await props.userRead('preference', { preference: 'Theme' });
      }

      const _prefVal = _pref.value;
      if((inTheme && !useTheme && _pref.isValid()) || newLoad){
        setUseTheme(true);
        const _el1 = document.getElementById('theme-grid');
        if(_el1) _el1.href = `/assets/theme/${_prefVal.theme}/css/grid.css`;
        const _el2 = document.getElementById('theme-style');
        if(_el2) _el2.href = `/assets/theme/${_prefVal.theme}/css/style.css`;
        const _el3 = document.getElementById('theme-nav');
        if(_el3) _el3.href = `/assets/theme/${_prefVal.theme}/css/nav.css`;
        const _el4 = document.getElementById('theme-block');
        if(_el4) _el4.href = `/assets/theme/${_prefVal.theme}/css/block.css`;
        const _el5 = document.getElementById('theme-color');
        if(_el5) _el5.href = `/assets/theme/${_prefVal.theme}/css/${_prefVal.color}.css`;
      }else if(!inTheme && useTheme){
        setUseTheme(false);
        const _el1 = document.getElementById('theme-grid');
        if(_el1) _el1.href = `/assets/theme/theme-01/css/grid.css`;
        const _el2 = document.getElementById('theme-style');
        if(_el2) _el2.href = `/assets/theme/theme-01/css/style.css`;
        const _el3 = document.getElementById('theme-nav');
        if(_el3) _el3.href = `/assets/theme/theme-01/css/nav.css`;
        const _el4 = document.getElementById('theme-block');
        if(_el4) _el4.href = `/assets/theme/theme-01/css/block.css`;
        const _el5 = document.getElementById('theme-color');
        if(_el5) _el5.href = `/assets/theme/theme-01/css/color-01.css`;
      }

      setTheme(_pref);
      setTimeout(() => dispatch({ type: APP_THEME, payload: _prefVal }), 1000);
    }
  };
  const onThemeToggle = (e=null) => {
    e?.preventDefault();
    setThemeProcess(!themeProcess);
  };
  const onThemeChage = (key, val) => {
    if(key === 'theme'){
      const _theme = [ ...props.themes ].find(d => d.value === val);
      if(_theme){
        const _color = _theme.colors?.[0] || null;
        if(_color){
          setTheme(new UserPreferenceModel({
            ...theme,
            value: { ...theme.value, theme: val, color: _color.value, isDark: _color.isDark },
          }));
          return;
        }
      }
    }
    setTheme(new UserPreferenceModel({
      ...theme,
      value: { ...theme.value, [key]: val },
    }));
    return;
  };
  const onThemeUpdate = async (e) => {
    e?.preventDefault();
    await props.userUpdate('preference', { preference: 'Theme', value: theme.value }, true);
    onThemeToggle();
    onThemeLoad(true);
  };
  // END: Theme


  const processSignout = async (e) => {
    e?.preventDefault();
    dispatch({ type: APP_THEME, payload: null });
    await props.processSignout();
    onSignout();
  };


  /* eslint-disable */
  useEffect(() => {
    props.feProcessList('app-themes');
    props.feProcessList('currencies');
  }, []);
  useEffect(() => {
    onCurrencyLoad();
  }, [user, lang]);

  useEffect(() => {
    const _inTheme = isSignedIn && (
      (currentPath.indexOf('/admin')===0 && user.isAdmin()) 
      || (currentPath.indexOf('/partner')===0 && user.isPartner()) 
      || (currentPath.indexOf('/sales-manager')===0 && user.isSalesManager()) 
      || (currentPath.indexOf('/external')===0 && user.isExAdmin()) 
      || (currentPath.indexOf('/supply-chain')===0 && user.isSupplyChainAdmin())
    );
    setInTheme(_inTheme);
  }, [isSignedIn, currentPath]);
  useEffect(() => {
    onThemeLoad();
  }, [settings['APP_ENABLE_THEME'], inTheme, props.themes]);

	useEffect(() => {
    if(Object.keys(settings).length){
      document.title = `${appName(settings['SYSTEM_NAME'])} Back Office`;
      if(settings['SYSTEM_COLOR_PRIMARY']){
        const _el = document.getElementById('system-style');
        if(_el){
          const rgb = hex2rgb(settings['SYSTEM_COLOR_PRIMARY']);
          const isLight = (rgb.r + rgb.g + rgb.b) / 3 > 200;
          _el.innerHTML = `
            :root{
              --p-color:${settings['SYSTEM_COLOR_PRIMARY']};
              --p-color-btn:${isLight? '#000000': '#ffffff'};
            }
          `;
        }
      }
      if(settings['SYSTEM_FAVICON']){
        const favicon = JSON.parse(unescape(settings['SYSTEM_FAVICON']));
        if(favicon.path){
          const favicon1 = document.getElementById('favicon-1');
          if(favicon1) favicon1.href = favicon.path;
          const favicon2 = document.getElementById('favicon-2');
          if(favicon2) favicon2.href = favicon.path;
        }
      }
      setIsReady(true);
    }
  }, [settings['SYSTEM_NAME'], settings['SYSTEM_COLOR_PRIMARY'], settings['SYSTEM_FAVICON']]);

	useEffect(() => {
    if(currentPath !== location.pathname){
      setCurrentPath(location.pathname);
      setSidenavActive(false);
      setMenuToggle(menu.map(() => false));
    }
  }, [location.pathname]);
  
	useEffect(() => {
    const onPreload = async () => {
      let _menu = [];
      if(isSignedIn){
        const shopTypes = partnerShops.map(d => d?.type ?? 0);
        const firebaseDB = getFirebaseDB(settings, externalShop);
        const _hasSubscription = ['CHAODOI'].indexOf(shopCode) < 0 && (
          settings['APP_MODULE_PARTNER_SUBSCRIPTION']==='1' 
          || settings['APP_MODULE_PARTNER_SUBSCRIPTION_COUPON']==='1'
        );
        if(user.isAdmin()){
          const isSuperAdmin = user.isSuperAdmin();
          _menu = [
            {
              title: 'Admin', indexMin: 1, indexMax: 20,
              children: [
                { title: 'Dashboard', to: '/admin', index: 1, icon: 'fa-solid fa-chart-simple' },
                { title: 'Admins', to: '/admin/admins', index: 2, icon: 'fa-solid fa-users' },
                settings['APP_ENABLE_MODULE_SALES_MANAGER']==='1' 
                  ? { title: 'Sales Managers', to: '/admin/sales-managers', index: 3, icon: 'fa-solid fa-people-group' }: null,
                { title: 'Shipping Statuses', to: '/admin/shipping-statuses', index: 4, icon: 'fa-solid fa-truck-ramp-box' },
                isSuperAdmin && SYSTEM_LANGUAGES.length > 1? { title: 'Languages', to: '/admin/languages', index: 6, icon: 'fa-solid fa-flag' }: null,
                isSuperAdmin? { title: 'Countries & Taxes', to: '/admin/data-countries', index: 7, icon: 'fa-solid fa-earth-americas' }: null,
                isSuperAdmin && settings['APP_LOG_USER_ENABLE']==='1' 
                  ? { title: 'User Logs', to: '/admin/user-logs', index: 9, icon: 'fa-solid fa-clock-rotate-left' }: null,
                isSuperAdmin && settings['APP_DATABASE_BACKUP_ENABLE']==='1' 
                  ? { title: 'Database Backups', to: '/admin/database-backups', index: 8, icon: 'fa-solid fa-database' }: null,
                isSuperAdmin? { title: 'Data Imports', to: '/admin/data-imports', index: 10, icon: 'fa-solid fa-cloud-arrow-up' }: null,
                isSuperAdmin? { title: 'Settings', to: '/admin/settings', index: 5, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Partner', indexMin: 21, indexMax: 40,
              children: [
                { title: 'Partners', to: '/admin/partners', index: 21, icon: 'fa-solid fa-users' },
                { title: 'Partner Shops', to: '/admin/partner-shops', index: 22, icon: 'fa-solid fa-shop' },
                { title: 'Product Categories', to: '/admin/partner-product-categories', index: 23, icon: 'fa-solid fa-box' },
                { title: 'Product Brands', to: '/admin/partner-product-brands', index: 24, icon: 'fa-solid fa-star' },
                { title: 'Product Statuses', to: '/admin/partner-product-statuses', index: 32, icon: 'fa-solid fa-flag' },
                { title: 'Products', to: '/admin/partner-products', index: 25, icon: 'fa-solid fa-basket-shopping' },
                settings['APP_MODULE_PARTNER_PRODUCT_SET']==='1' 
                  ? { title: 'Product Sets', to: '/admin/partner-product-sets', index: 30, icon: 'fa-solid fa-bag-shopping' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_REWARD']==='1' 
                  ? { title: 'Product Giveaway Rules', to: '/admin/partner-product-giveaway-rules', index: 33, icon: 'fa-solid fa-gift' }: null,
                settings['APP_MODULE_PARTNER_SUBSCRIPTION']==='1' 
                  ? { title: 'Product Subscriptions', to: '/admin/partner-product-subscriptions', index: 34, icon: 'fas fa-award' }: null,
                settings['APP_MODULE_PARTNER_SUBSCRIPTION_COUPON']==='1' 
                  ? { title: 'Coupon Subscriptions', to: '/admin/partner-coupon-subscriptions', index: 35, icon: 'fas fa-award' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' || settings['APP_ENABLE_FEATURE_PARTNER_CASH_COUPON']==='1' 
                  ? { title: 'Product Coupons', to: '/admin/partner-product-coupons', index: 26, icon: 'fa-solid fa-tags' }: null,
                { title: 'Shipping Methods', to: '/admin/partner-shippings', index: 27, icon: 'fa-solid fa-truck-ramp-box' },
                settings['APP_ENABLE_FEATURE_PARTNER_SHIPPING_COUPON']==='1' 
                  ? { title: 'Shipping Coupons', to: '/admin/partner-shipping-coupons', index: 28, icon: 'fa-solid fa-tags' }: null,
                settings['APP_MODULE_PARTNER_EVENT']==='1' 
                  ? { title: 'Events', to: '/admin/partner-events', index: 31, icon: 'fa-solid fa-calendar-days' }: null,
                isSuperAdmin? 
                  settings['APP_ENABLE_SERVICE_FEE']==='1' 
                    ? { title: 'Settings', to: '/admin/partner-settings', index: 29, icon: 'fa-solid fa-gear' } 
                    : { title: 'Free Shipping Rule', to: '/admin/partner-settings', index: 29, icon: 'fa-solid fa-truck' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Customer', indexMin: 41, indexMax: 60,
              children: [
                settings['APP_MODULE_CUSTOMER_GROUP']==='1' 
                  ? { title: 'Customer Groups', to: '/admin/customer-groups', index: 50, icon: 'fa-solid fa-people-line' }: null,
                { title: 'Customer Tiers', to: '/admin/customer-tiers', index: 41, icon: 'fa-solid fa-crown' },
                { title: 'Customers', to: '/admin/customers', index: 42, icon: 'fa-solid fa-users' },
                { title: 'Guest Accounts', to: '/admin/customer-guests', index: 46, icon: 'fa-solid fa-users' },
                { title: 'Orders', to: '/admin/customer-orders', index: 43, icon: 'fa-solid fa-credit-card' },
                settings['APP_MODULE_INTEGRATION_SAP']==='1' 
                  ? { title: 'Syncing Orders', to: '/admin/customer-syncing-orders', index: 53, icon: 'fa-solid fa-rotate' }: null,
                settings['APP_MODULE_PAYMENT_2C2P']==='1' 
                  ? { title: '2C2P Carts', to: '/admin/customer-2c2p-carts', index: 47, icon: 'fa-solid fa-shield' }: null,
                settings['APP_MODULE_PAYMENT_STRIPE']==='1' 
                  ? { title: 'Stripe Carts', to: '/admin/customer-stripe-carts', index: 48, icon: 'fa-solid fa-shield' }: null,
                _hasSubscription 
                  ? { title: '2C2P Subscription Carts', to: '/admin/customer-subscription-2c2p-carts', index: 51, icon: 'fa-solid fa-shield' }: null,
                _hasSubscription 
                  ? { title: '2C2P Subscription Charges', to: '/admin/customer-subscription-charges', index: 52, icon: 'fa-regular fa-credit-card' }: null,
                firebaseDB && settings['APP_MODULE_CHAT_CUSTOMER']==='1' && settings[`${prefix}ENABLE_CHAT_CUSTOMER`]==='1' 
                  ? { title: 'Messages', to: '/admin/customer-messages', index: 44, icon: 'fa-solid fa-message' }: null,
                firebaseDB && settings['APP_MODULE_CHAT_GUEST']==='1' && settings[`${prefix}ENABLE_CHAT_GUEST`]==='1' 
                  ? { title: 'Guest Messages', to: '/admin/guest-messages', index: 49, icon: 'fa-solid fa-message' }: null,
                settings['MOBILE_ENABLE']==='1' 
                  ? { title: 'Notifications', to: '/admin/customer-notifications', index: 45, icon: 'fa-solid fa-bullhorn' }: null,
              ].filter(d => d?.title),
            },
            settings['APP_MODULE_SELLER']==='1'? {
              title: 'Seller', indexMin: 61, indexMax: 80,
              children: [
                { title: 'Seller Shop Brands', to: '/admin/seller-shop-brands', index: 64, icon: 'fa-solid fa-star' },
                { title: 'Seller Shop Types', to: '/admin/seller-shop-types', index: 61, icon: 'fa-solid fa-crown' },
                { title: 'Seller Shops', to: '/admin/seller-shops', index: 63, icon: 'fa-solid fa-shop' },
              ].filter(d => d?.title),
            }: null,
            {
              title: 'Content Management', indexMin: 111, indexMax: 120,
              children: [
                { title: 'Content Categories', to: '/admin/cms-content-categories', index: 111, icon: 'fa-solid fa-layer-group' },
                { title: 'Contents', to: '/admin/cms-contents', index: 112, icon: 'fa-solid fa-book-open' },
                { title: 'Banners', to: '/admin/cms-banners', index: 113, icon: 'fa-solid fa-star' },
                { title: 'Popups', to: '/admin/cms-popups', index: 114, icon: 'fa-solid fa-clipboard' },
                settings['APP_MODULE_CMS_PARTNER_PRODUCT_SECTION'] === '1'
                ? { title: 'Partner Product Section', to: '/admin/cms-partner-product-sections', index: 117, icon: 'fa-solid fa-layer-group' }
                : null,
                settings['APP_MODULE_CMS_CHECKOUT']==='1' 
                  ? { title: 'Checkout Contents', to: '/admin/cms-checkout-contents', index: 116, icon: 'fa-solid fa-rectangle-ad' }: null,
                isSuperAdmin? { title: 'Settings', to: '/admin/cms-settings', index: 115, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Business Report', indexMin: 301, indexMax: 400,
              children: [
                {
                  title: 'Partner Shops', to: '/admin/report-partner-shops',
                  index: 301, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_shops'
                },
                settings['APP_REPORT_PARTNER_PERFORMANCE']==='1'? {
                  title: 'Partner Performances', to: '/admin/report-partner-performances',
                  index: 302, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_performances'
                }: null,
                false? {
                  title: 'Partner Commissions', to: '/admin/report-partner-commissions',
                  index: 303, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_commissions'
                }: null,
                settings['APP_REPORT_PARTNER_PRODUCT']==='1'? {
                  title: 'Partner Products', to: '/admin/report-partner-products',
                  index: 304, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_products'
                }: null,
                settings['APP_REPORT_PARTNER_PRODUCT_MIX_TRACKING']==='1'? {
                  title: 'Partner Product Mix Trackings', to: '/admin/report-partner-product-mix-trackings',
                  index: 305, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_product_mix_trackings'
                }: null,
                settings['APP_REPORT_PARTNER_COUPON']==='1' 
                && (settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' 
                || settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' 
                || settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1')? {
                  title: 'Partner Coupons', to: '/admin/report-partner-coupons',
                  index: 306, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_coupons'
                }: null,
                settings['APP_REPORT_PARTNER_EVENT']==='1' && settings['APP_MODULE_PARTNER_EVENT']==='1'? {
                  title: 'Partner Events', to: '/admin/report-partner-events',
                  index: 307, icon: 'fa-solid fa-chart-column',
                  value: 'report_partner_events'
                }: null,
                settings['APP_REPORT_CUSTOMER']==='1'? {
                  title: 'Customers', to: '/admin/report-customers',
                  index: 308, icon: 'fa-solid fa-chart-column',
                  value: 'report_customers'
                }: null,
                settings['APP_REPORT_CUSTOMER_ORDER']==='1'? {
                  title: 'Customer Orders', to: '/admin/report-customer-orders',
                  index: 309, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_orders'
                }: null,
                settings['APP_REPORT_CUSTOMER_PRODUCT_ORDER']==='1'? {
                  title: 'Customer Product Orders', to: '/admin/report-customer-product-orders',
                  index: 310, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_product_orders'
                }: null,
                settings['APP_REPORT_CUSTOMER_PURCHASING']==='1'? {
                  title: 'Customer Purchasings', to: '/admin/report-customer-purchasings',
                  index: 311, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_purchasings'
                }: null,
                settings['APP_REPORT_CUSTOMER_PURCHASE_CATEGORY']==='1'? {
                  title: 'Customer Purchase Categories', to: '/admin/report-customer-purchase-categories',
                  index: 312, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_purchase_categories'
                }: null,
                settings['APP_REPORT_CUSTOMER_UNPURCHASE_CATEGORY']==='1'? {
                  title: 'Customer Unpurchase Categories', to: '/admin/report-customer-unpurchase-categories',
                  index: 313, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_unpurchase_categories'
                }: null,
                false? {
                  title: 'Customer Settlements', to: '/admin/report-customer-settlements',
                  index: 314, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_settlements'
                }: null,
                settings['APP_REPORT_CUSTOMER_TRACKING']==='1'? {
                  title: 'Customer Trackings', to: '/admin/report-customer-trackings',
                  index: 315, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_trackings'
                }: null,
                settings['APP_REPORT_CUSTOMER_PURCHASE_TIER']==='1'? {
                  title: 'Customer Purchase Tiers', to: '/admin/report-customer-purchase-tiers',
                  index: 316, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_purchase_tiers'
                }: null,
                settings['APP_REPORT_CUSTOMER_SUBSCRIPTION']==='1'? {
                  title: 'Customer Subscriptions', to: '/admin/report-customer-subscriptions',
                  index: 317, icon: 'fa-solid fa-chart-column',
                  value: 'report_customer_subscriptions'
                }: null,
              ].filter(d => {
                if(!d?.title) return false;
                if(!d?.value) return true;
                return checkPermission(user, permissions, d.value);
              }),
            },
            settings['APP_MODULE_MARKETING_TOOL']==='1'? {
              title: 'Marketing Tools', indexMin: 131, indexMax: 140,
              children: [
                settings['APP_MODULE_MARKETING_TOOL_PRODUCT_PROMOTION']==='1'?
                  { title: 'Product Promotion', to: '/admin/tool-partner-product-promotions', index: 132, icon: 'fa-solid fa-tags' }: null,
                settings['APP_MODULE_MARKETING_TOOL_COUPON_DISTRIBUTION']==='1'?
                  { title: 'Coupon Distribution', to: '/admin/tool-partner-coupon-distribution', index: 133, icon: 'fa-solid fa-gift' }: null,
                settings['APP_MODULE_MARKETING_TOOL_CUSTOMER_QUOTATION']==='1'?
                  { title: 'Customer Quotation', to: '/admin/tool-customer-quotations', index: 134, icon: 'fa-solid fa-money-bill-1', value: 'tool_customer_quotation' }: null,
                settings['APP_MODULE_MARKETING_TOOL_CUSTOMER_CARD_SCANNER']==='1'?
                  { title: 'Customer Card Scanner', to: '/admin/tool-customer-card-scanner', index: 131, icon: 'fa-solid fa-id-card' }: null,
              ].filter(d => {
                if(!d?.title) return false;
                if(!d?.value) return true;
                return checkPermission(user, permissions, d.value);
              }),
            }: null,
            settings['APP_MODULE_EXTERNAL_APP']==='1' && isSuperAdmin? {
              title: 'External App', indexMin: 121, indexMax: 130,
              children: [
                { title: 'External Shops', to: '/admin/external-shops', index: 122, icon: 'fa-solid fa-shop' },
                { title: 'External Admins', to: '/admin/external-admins', index: 121, icon: 'fa-solid fa-users' },
              ].filter(d => d?.title),
            }: null,
            settings['APP_MODULE_SUPPLY_CHAIN']==='1' && isSuperAdmin? {
              title: 'Supply Chain', indexMin: 201, indexMax: 220,
              children: [
                { title: 'Supply Chain Admins', to: '/admin/supply-chain-admins', index: 200, icon: 'fa-solid fa-users' },
              ].filter(d => d?.title),
            }: null,
          ].filter(d => d?.title);
        }else if(user.isPartner()){
          const withCommission = (settings['APP_COMMISSION_PARTNER_CENTER']==='1' && shopTypes.indexOf(1) > -1) 
            || (settings['APP_COMMISSION_PARTNER_PARTNER']==='1' && shopTypes.indexOf(2) > -1) 
            || (settings['APP_COMMISSION_PARTNER_DEALER']==='1' && shopTypes.indexOf(3) > -1);
          _menu = [
            {
              title: 'Partner', indexMin: 1, indexMax: 20,
              children: [
                { title: 'Dashboard', to: '/partner', index: 1, icon: 'fa-solid fa-chart-simple' },
                user.partnerShops.length? { title: 'Register Customer', to: '/partner/register-customer', index: 2, icon: 'fa-solid fa-user-plus' }: null,
                { title: 'Sales Report', to: '/partner/sales-report', index: 3, icon: 'fa-solid fa-chart-column' },
                withCommission? { title: 'Commission Table', to: '/partner/commission-table', index: 4, icon: 'fa-solid fa-table-list' }: false,
                withCommission? { title: 'Commissions', to: '/partner/commissions', index: 5, icon: 'fa-solid fa-star' }: false,
                withCommission? { title: 'Commission Report', to: '/partner/commission-report', index: 6, icon: 'fa-solid fa-chart-column' }: false,
              ].filter(d => d?.title),
            }, {
              title: 'Partner', indexMin: 21, indexMax: 40,
              children: [
                user.partnerShops.length? { title: 'Partner Shops', to: '/partner/partner-shops', index: 22, icon: 'fa-solid fa-shop' }: null,
                { title: 'Products', to: '/partner/partner-products', index: 25, icon: 'fa-solid fa-basket-shopping' },
                settings['APP_MODULE_PARTNER_PRODUCT_SET']==='1' 
                  ? { title: 'Product Sets', to: '/partner/partner-product-sets', index: 30, icon: 'fa-solid fa-bag-shopping' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_REWARD']==='1' 
                  ? { title: 'Product Giveaway Rules', to: '/partner/partner-product-giveaway-rules', index: 33, icon: 'fa-solid fa-gift' }: null,
                settings['APP_MODULE_PARTNER_SUBSCRIPTION']==='1' 
                  ? { title: 'Product Subscriptions', to: '/partner/partner-product-subscriptions', index: 34, icon: 'fas fa-award' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' || settings['APP_ENABLE_FEATURE_PARTNER_CASH_COUPON']==='1' 
                  ? { title: 'Product Coupons', to: '/partner/partner-product-coupons', index: 26, icon: 'fa-solid fa-tags' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_SHIPPING_COUPON']==='1' 
                  ? { title: 'Shipping Coupons', to: '/partner/partner-shipping-coupons', index: 28, icon: 'fa-solid fa-tags' }: null,
              ].filter(d => d?.title),
            }, {
              title: 'Customer', indexMin: 41, indexMax: 60,
              children: [
                { title: 'Customers', to: '/partner/customers', index: 42, icon: 'fa-solid fa-users' },
                { title: 'Orders', to: '/partner/customer-orders', index: 43, icon: 'fa-solid fa-credit-card' },
                settings['APP_MODULE_INTEGRATION_SAP']==='1' 
                  ? { title: 'Syncing Orders', to: '/partner/customer-syncing-orders', index: 53, icon: 'fa-solid fa-rotate' }: null,
                firebaseDB && settings['APP_MODULE_CHAT_CUSTOMER']==='1' && settings[`${prefix}ENABLE_CHAT_CUSTOMER`]==='1' 
                  ? { title: 'Messages', to: '/partner/customer-messages', index: 44, icon: 'fa-solid fa-message' }: null,
              ].filter(d => d?.title),
            },
          ].filter(d => d?.title);
        }else if(user.isSalesManager()){
          const withCommission = (externalShop.isValid() && settings[`${prefix}APP_COMMISSION_SALES`]==='1') 
            || (settings['APP_COMMISSION_SALES']==='1' && !shopTypes.length) 
            || (settings['APP_COMMISSION_SALES_CENTER']==='1' && shopTypes.indexOf(1) > -1) 
            || (settings['APP_COMMISSION_SALES_PARTNER']==='1' && shopTypes.indexOf(2) > -1) 
            || (settings['APP_COMMISSION_SALES_DEALER']==='1' && shopTypes.indexOf(3) > -1);
          _menu = [
            {
              title: 'Sales Manager', indexMin: 1, indexMax: 20,
              children: [
                { title: 'Dashboard', to: '/sales-manager', index: 1, icon: 'fa-solid fa-chart-simple' },
                { title: 'Register Customer', to: '/sales-manager/register-customer', index: 2, icon: 'fa-solid fa-user-plus' },
                { title: 'Sales Report', to: '/sales-manager/sales-report', index: 3, icon: 'fa-solid fa-chart-column' },
                withCommission? { title: 'Commission Table', to: '/sales-manager/commission-table', index: 4, icon: 'fa-solid fa-table-list' }: null,
                withCommission? { title: 'Commissions', to: '/sales-manager/commissions', index: 5, icon: 'fa-solid fa-star' }: null,
                withCommission? { title: 'Commission Report', to: '/sales-manager/commission-report', index: 6, icon: 'fa-solid fa-chart-column' }: null,
              ].filter(d => d?.title),
            }, {
              title: 'Partner', indexMin: 21, indexMax: 40,
              children: [
                user.partnerShops.length? { title: 'Partner Shops', to: '/sales-manager/partner-shops', index: 22, icon: 'fa-solid fa-shop' }: null,
                { title: 'Products', to: '/sales-manager/partner-products', index: 25, icon: 'fa-solid fa-basket-shopping' },
                settings['APP_MODULE_PARTNER_PRODUCT_SET']==='1' 
                  ? { title: 'Product Sets', to: '/sales-manager/partner-product-sets', index: 30, icon: 'fa-solid fa-bag-shopping' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_REWARD']==='1' 
                  ? { title: 'Product Giveaway Rules', to: '/sales-manager/partner-product-giveaway-rules', index: 33, icon: 'fa-solid fa-gift' }: null,
                settings['APP_MODULE_PARTNER_SUBSCRIPTION']==='1' 
                  ? { title: 'Product Subscriptions', to: '/sales-manager/partner-product-subscriptions', index: 34, icon: 'fas fa-award' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' || settings['APP_ENABLE_FEATURE_PARTNER_CASH_COUPON']==='1' 
                  ? { title: 'Product Coupons', to: '/sales-manager/partner-product-coupons', index: 26, icon: 'fa-solid fa-tags' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_SHIPPING_COUPON']==='1' 
                  ? { title: 'Shipping Coupons', to: '/sales-manager/partner-shipping-coupons', index: 28, icon: 'fa-solid fa-tags' }: null,
              ].filter(d => d?.title),
            }, {
              title: 'Customer', indexMin: 41, indexMax: 60,
              children: [
                { title: 'Customers', to: '/sales-manager/customers', index: 42, icon: 'fa-solid fa-users' },
                { title: 'Orders', to: '/sales-manager/customer-orders', index: 43, icon: 'fa-solid fa-credit-card' },
                settings['APP_MODULE_INTEGRATION_SAP']==='1' 
                  ? { title: 'Syncing Orders', to: '/sales-manager/customer-syncing-orders', index: 53, icon: 'fa-solid fa-rotate' }: null,
                firebaseDB && settings['APP_MODULE_CHAT_CUSTOMER']==='1' && settings[`${prefix}ENABLE_CHAT_CUSTOMER`]==='1' 
                  ? { title: 'Messages', to: '/sales-manager/customer-messages', index: 44, icon: 'fa-solid fa-message' }: null,
              ].filter(d => d?.title),
            }, (prefix ? settings[`${prefix}APP_MODULE_MARKETING_TOOL`]==='1' : settings['APP_MODULE_MARKETING_TOOL'] === '1') ? {
              title: 'Marketing Tools', indexMin: 61, indexMax: 80,
              children: [
                (prefix ? settings[`${prefix}APP_MODULE_MARKETING_TOOL_CUSTOMER_QUOTATION`] === '1' : settings['APP_MODULE_MARKETING_TOOL_CUSTOMER_QUOTATION'] === '1') ?
                { title: 'Customer Quotation', to: '/sales-manager/tool-customer-quotations', index: 62, icon: 'fa-solid fa-money-bill-1', value: 'tool_customer_quotation' }: null,
              ].filter(d => {
                if(!d?.title) return false;
                if(!d?.value) return true;
                return checkPermission(user, permissions, d.value);
              }),
            }: null,
          ].filter(d => d?.title);
        }else if(user.isExAdmin() && externalShop.isValid()){
          const isExSuperAdmin = user.isExSuperAdmin();
          _menu = [
            {
              title: 'Admin', indexMin: 1, indexMax: 20,
              children: [
                { title: 'Dashboard', to: '/external', index: 1, icon: 'fa-solid fa-chart-simple' },
                { title: 'Admins', to: '/external/admins', index: 2, icon: 'fa-solid fa-users' },
                settings['APP_ENABLE_MODULE_SALES_MANAGER']==='1' 
                  ? { title: 'Sales Managers', to: '/external/sales-managers', index: 3, icon: 'fa-solid fa-people-group' }: null,
                { title: 'Shipping Statuses', to: '/external/shipping-statuses', index: 4, icon: 'fa-solid fa-truck-ramp-box' },
                isExSuperAdmin? { title: 'Settings', to: '/external/settings', index: 5, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Partner', indexMin: 21, indexMax: 40,
              children: [
                { title: 'Product Categories', to: '/external/partner-product-categories', index: 23, icon: 'fa-solid fa-box' },
                { title: 'Product Brands', to: '/external/partner-product-brands', index: 24, icon: 'fa-solid fa-star' },
                { title: 'Products', to: '/external/partner-products', index: 25, icon: 'fa-solid fa-basket-shopping' },
                settings['APP_MODULE_PARTNER_PRODUCT_SET']==='1' 
                  ? { title: 'Product Sets', to: '/external/partner-product-sets', index: 30, icon: 'fa-solid fa-bag-shopping' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_REWARD']==='1' 
                  ? { title: 'Product Giveaway Rules', to: '/external/partner-product-giveaway-rules', index: 33, icon: 'fa-solid fa-gift' }: null,
                ['CHAODOI'].indexOf(shopCode) < 0 && 
                settings['APP_MODULE_PARTNER_SUBSCRIPTION']==='1' 
                && settings[`${prefix}APP_MODULE_PARTNER_SUBSCRIPTION`]==='1' 
                  ? { title: 'Product Subscriptions', to: '/external/partner-product-subscriptions', index: 34, icon: 'fas fa-award' }: null,
                ['CHAODOI'].indexOf(shopCode) < 0 && 
                settings['APP_MODULE_PARTNER_SUBSCRIPTION_COUPON']==='1' 
                && settings[`${prefix}APP_MODULE_PARTNER_SUBSCRIPTION_COUPON`]==='1' 
                  ? { title: 'Coupon Subscriptions', to: '/external/partner-coupon-subscriptions', index: 35, icon: 'fas fa-award' }: null,
                settings['APP_ENABLE_FEATURE_PARTNER_PRODUCT_COUPON']==='1' || settings['APP_ENABLE_FEATURE_PARTNER_CASH_COUPON']==='1' 
                  ? { title: 'Product Coupons', to: '/external/partner-product-coupons', index: 26, icon: 'fa-solid fa-tags' }: null,
                { title: 'Shipping Methods', to: '/external/partner-shippings', index: 27, icon: 'fa-solid fa-truck-ramp-box' },
                settings['APP_ENABLE_FEATURE_PARTNER_SHIPPING_COUPON']==='1' 
                  ? { title: 'Shipping Coupons', to: '/external/partner-shipping-coupons', index: 28, icon: 'fa-solid fa-tags' }: null,
                isExSuperAdmin? { title: 'Settings', to: '/external/partner-settings', index: 29, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Customer', indexMin: 41, indexMax: 60,
              children: [
                settings['APP_MODULE_CUSTOMER_GROUP']==='1' 
                  ? { title: 'Customer Groups', to: '/external/customer-groups', index: 50, icon: 'fa-solid fa-crown' }: null,
                { title: 'Customer Tiers', to: '/external/customer-tiers', index: 41, icon: 'fa-solid fa-crown' },
                { title: 'Customers', to: '/external/customers', index: 42, icon: 'fa-solid fa-users' },
                { title: 'Orders', to: '/external/customer-orders', index: 43, icon: 'fa-solid fa-credit-card' },
                { title: 'Syncing Orders', to: '/external/customer-syncing-orders', index: 53, icon: 'fa-solid fa-rotate' },
                settings['APP_MODULE_PAYMENT_2C2P']==='1' 
                  ? { title: '2C2P Carts', to: '/external/customer-2c2p-carts', index: 47, icon: 'fa-solid fa-shield' }: null,
                _hasSubscription 
                  ? { title: '2C2P Subscription Carts', to: '/external/customer-subscription-2c2p-carts', index: 51, icon: 'fa-solid fa-shield' }: null,
                _hasSubscription 
                  ? { title: '2C2P Subscription Charges', to: '/external/customer-subscription-charges', index: 52, icon: 'fa-regular fa-credit-card' }: null,
                firebaseDB && settings['APP_MODULE_CHAT_CUSTOMER']==='1' && settings[`${prefix}ENABLE_CHAT_CUSTOMER`]==='1' 
                  ? { title: 'Messages', to: '/external/customer-messages', index: 44, icon: 'fa-solid fa-message' }: null,
                ['CHAODOI'].indexOf(shopCode) < 0 && 
                firebaseDB && settings['APP_MODULE_CHAT_GUEST']==='1' && settings[`${prefix}ENABLE_CHAT_GUEST`]==='1' 
                  ? { title: 'Guest Messages', to: '/external/guest-messages', index: 49, icon: 'fa-solid fa-message' }: null,
              ].filter(d => d?.title),
            },
            settings['APP_MODULE_SELLER']==='1' && sellerShopBrands.length? {
              title: 'Seller', indexMin: 61, indexMax: 80,
              children: [
                { title: 'Seller Shop Brands', to: '/external/seller-shop-brands', index: 64, icon: 'fa-solid fa-star' },
                { title: 'Seller Shops', to: '/external/seller-shops', index: 63, icon: 'fa-solid fa-shop' },
              ].filter(d => d?.title),
            }: null,
            {
              title: 'Content Management', indexMin: 111, indexMax: 120,
              children: [
                { title: 'Content Categories', to: '/external/cms-content-categories', index: 111, icon: 'fa-solid fa-layer-group' },
                { title: 'Contents', to: '/external/cms-contents', index: 112, icon: 'fa-solid fa-book-open' },
                { title: 'Banners', to: '/external/cms-banners', index: 113, icon: 'fa-solid fa-star' },
                { title: 'Popups', to: '/external/cms-popups', index: 114, icon: 'fa-solid fa-clipboard' },
                settings[`${prefix}APP_MODULE_CMS_PARTNER_PRODUCT_SECTION`] === '1'
                  ? { title: 'Partner Product Section', to: '/external/cms-partner-product-sections', index: 117, icon: 'fa-solid fa-layer-group' }: null,
                ['CHAODOI'].indexOf(shopCode) < 0 && isExSuperAdmin? { title: 'Settings', to: '/external/cms-settings', index: 115, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
            {
              title: 'Business Report', indexMin: 301, indexMax: 400,
              children: [
                { title: 'Partner Shops', to: '/external/report-partner-shops', index: 301, icon: 'fa-solid fa-chart-column' },
                { title: 'Partner Products', to: '/external/report-partner-products', index: 302, icon: 'fa-solid fa-chart-column' },
                { title: 'Partner Coupons', to: '/external/report-partner-coupons', index: 303, icon: 'fa-solid fa-chart-column' },
                { title: 'Customers', to: '/external/report-customers', index: 304, icon: 'fa-solid fa-chart-column' },
                { title: 'Customer Orders', to: '/external/report-customer-orders', index: 305, icon: 'fa-solid fa-chart-column' },
                { title: 'Customer Product Orders', to: '/external/report-customer-product-orders', index: 306, icon: 'fa-solid fa-chart-column' },
                ['CHAODOI'].indexOf(shopCode) < 0 && 
                settings['APP_REPORT_CUSTOMER_SUBSCRIPTION']==='1'? {
                  title: 'Customer Subscriptions', to: '/external/report-customer-subscriptions', index: 317, icon: 'fa-solid fa-chart-column',
                }: null,
              ].filter(d => d?.title),
            },
            settings[`${prefix}APP_MODULE_MARKETING_TOOL`]==='1'? {
              title: 'Marketing Tools', indexMin: 131, indexMax: 140,
              children: [
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_CLAIM_POINT`]==='1'?
                  { title: 'Claim Points', to: '/external/tool-claim-points', index: 133, icon: 'fa-solid fa-tags' }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_CUSTOMER_QUOTATION`]==='1'?
                  { title: 'Customer Quotations', to: '/external/tool-customer-quotations', index: 136, icon: 'fa-solid fa-file-invoice', value: 'tool_customer_quotation'  }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_ARTWORK`]==='1'?
                  { title: 'Artwork Categories', to: '/external/tool-customer-artwork-categories', index: 135, icon: 'fa-solid fa-palette' }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_ARTWORK`]==='1'?
                  { title: 'Artworks', to: '/external/tool-customer-artworks', index: 134, icon: 'fa-solid fa-palette' }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_CUSTOMER_FILE`]==='1'?
                  { title: 'Policy Categories', to: '/external/tool-customer-file-categories', index: 137, icon: 'fa-solid fa-palette' }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_CUSTOMER_FILE`]==='1'?
                  { title: 'Documents & Policies', to: '/external/tool-customer-files', index: 138, icon: 'fa-solid fa-palette' }: null,
                settings[`${prefix}APP_MODULE_MARKETING_TOOL_COUPON_DISTRIBUTION`]==='1'?
                  { title: 'Coupon Distribution', to: '/external/tool-partner-coupon-distribution', index: 139, icon: 'fa-solid fa-palette' }: null,
              ].filter(d => {
                if(!d?.title) return false;
                if(!d?.value) return true;
                return checkPermission(user, permissions, d.value);
              }),
            }: null,
          ].filter(d => d?.title);
        }else if(user.isSupplyChainAdmin()){
          const isSuperAdmin = user.isSupplyChainSuperAdmin();
          _menu = [
            {
              title: 'Supply Chain', indexMin: 1, indexMax: 20,
              children: [
                { title: 'Dashboard', to: '/supply-chain', index: 1, icon: 'fa-solid fa-chart-simple' },
                { title: 'Admins', to: '/supply-chain/admins', index: 2, icon: 'fa-solid fa-users' },
                { title: 'Warehouses', to: '/supply-chain/warehouses', index: 9, icon: 'fa-solid fa-warehouse' },
                { title: 'Partner Shops', to: '/supply-chain/partner-shops', index: 10, icon: 'fa-solid fa-shop' },
                isSuperAdmin? { title: 'Settings', to: '/supply-chain/settings', index: 5, icon: 'fa-solid fa-gear' }: null,
              ].filter(d => d?.title),
            },
          ].filter(d => d?.title);
        }
      }
      setMenu(_menu);
      setMenuToggle(_menu.map(() => false));
    };
    onPreload();
  }, [user, settings]);
  /* eslint-enable */

  if(!isReady || !props.theme || currentPath.indexOf('/setup') === 0) return (<></>);
  return !isSignedIn? (<>
    {DEV_PROCESS? (
      <div className="dev-notice">
        <div className="ss-tag bg-danger bradius">
          <p className="fw-700 ls-1">{DEV_MODE}</p>
        </div>
      </div>
    ): (<></>)}
    {SYSTEM_LANGUAGES.length > 1 && lang? (
      <div className="global-lang">
        <div className="wrapper">
          <div className="lang-item">
            <div className="flag" style={{ backgroundImage: `url('/assets/img/flag/${lang}.jpg')` }}></div>
            <div className="lang">{lang}</div>
          </div>
          <div className="dropdown bcolor-fgray">
            <div className="wrapper">
              {SYSTEM_LANGUAGES.map((d, i) => (
                <Fragment key={`lang_${i}`}>
                  {d !== lang? (
                    <div className="lang-item" onClick={e => processLanguageUpdate(e, d)}>
                      <div className="flag" style={{ backgroundImage: `url('/assets/img/flag/${d}.jpg')` }}></div>
                      <div className="lang">{d}</div>
                    </div>
                  ): (<></>)}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    ): (<></>)}
  </>): (
    ( currentPath.indexOf('/admin') === 0 && user.isAdmin() ) 
    || ( currentPath.indexOf('/partner') === 0 && user.isPartner() ) 
    || ( currentPath.indexOf('/sales-manager') === 0 && user.isSalesManager() ) 
    || ( currentPath.indexOf('/external') === 0 && user.isExAdmin() ) 
    || ( currentPath.indexOf('/supply-chain') === 0 && user.isSupplyChainAdmin() )? (<>
      {/* Topnav */}
      <nav className="topnav bcolor-fgray">
        <div className="wrapper">
          <Link to={user.path()} className="logo-container h-color-p">
            <img className="logo" alt="Logo" 
              src={appLogo(settings[`${prefix}SYSTEM_LOGO`] || settings[`SYSTEM_LOGO`], false)} 
            />
            <div className="text fw-900">
              {appShortName(settings[`${prefix}SYSTEM_SHORT_NAME`] || settings[`SYSTEM_SHORT_NAME`], false)} 
            </div>
          </Link>
          {currentPath.indexOf('/admin/intelligence') < 0? (
            <div className="sidenav-toggle" onClick={onSidenavActiveToggle}>
              <div className={`hamburger ${sidenavActive? 'active': ''}`}>
                <div></div><div></div><div></div>
              </div>
            </div>
          ): (<></>)}
          
          {DEV_PROCESS? (
            <div className="ss-tag bg-danger bradius">
              <p className="fw-700 ls-1">{DEV_MODE}</p>
            </div>
          ): (<></>)}

          <div className="options">
            <TopnavRealTime />

            {/* Currency */}
            {settings['APP_ENABLE_MULTI_CURRENCIES'] === '1' && props.currencies.length? (
              <div className="option">
                <div className="option-icon">
                  <div className="text">{props.useCurrency.code}</div>
                </div>
                <div className="dropdown bcolor-fgray w-auto" style={{ left: 0 }}>
                  <div className="wrapper p-0 pt-1 pb-1">
                    {props.currencies.map((d, i) => (
                      <Fragment key={`currency_${i}`}>
                        {d.status && d._id !== props.useCurrency._id? (
                          <div className="currency-item" onClick={e => onCurrencyChange(e, d)}>
                            <p className="sm fw-500 text-center">{d.code}</p>
                          </div>
                        ): (<></>)}
                      </Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ): (<></>)}

            {/* Language */}
            {SYSTEM_LANGUAGES.length > 1 && lang? (
              <div className="option">
                <div className="option-icon">
                  <div className="flag bcolor-sgray" style={{ backgroundImage: `url('/assets/img/flag/${lang}.jpg')` }}></div>
                </div>
                <div className="dropdown bcolor-fgray w-auto" style={{ right: '.5rem' }}>
                  <div className="wrapper p-0 pt-1 pb-1">
                    {SYSTEM_LANGUAGES.map((d, i) => (
                      <Fragment key={`lang_${i}`}>
                        {d !== lang? (
                          <div className="lang-item" onClick={e => processLanguageUpdate(e, d)}>
                            <div className="flag bcolor-sgray" style={{ backgroundImage: `url('/assets/img/flag/${d}.jpg')` }}></div>
                          </div>
                        ): (<></>)}
                      </Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ): (<></>)}

            {/* Profile */}
            <div className="option">
              <div className="option-icon">
                <div className="avatar xs">
                  <div className="avatar-bg" style={{ backgroundImage: `url('${user.avatar.path}')` }}></div>
                </div>
              </div>
              <div className="dropdown bcolor-fgray">
                <div className="wrapper bcolor-fgray">
                  <h6 className="name">{user.displayName()}</h6>
                  <p className="role color-gray">{translate('Role', langObj)} : {user.displayRole()}</p>
                </div>
                <div className="wrapper bcolor-fgray">
                  <Link to={`${user.path()}/profile`} className="dropdown-item">
                    <div className="icon"><em className="fa-solid fa-user"></em></div>
                    {translate('Personal Info', langObj)}
                  </Link>
                  {user.isOwner? (
                    <Link to={`${user.path()}/app-settings`} className="dropdown-item">
                      <div className="icon"><em className="fa-solid fa-gear"></em></div>
                      {translate('App Settings', langObj)}
                    </Link>
                  ): (<></>)}
                  {false && user.isSuperAdmin()? (
                    <Link to={`${user.path()}/data-import`} className="dropdown-item">
                      <div className="icon"><em className="fa-solid fa-file-import"></em></div>
                      {translate('Data Import', langObj)}
                    </Link>
                  ): (<></>)}
                  {settings['APP_ENABLE_THEME'] === '1' && props.themes?.length? (
                    <div className="dropdown-item c-pointer" onClick={onThemeToggle}>
                      <div className="icon"><em className="fa-solid fa-palette"></em></div>
                      {translate('Theme Settings', langObj)}
                    </div>
                  ): (<></>)}
                  <div className="dropdown-item c-pointer" onClick={processSignout}>
                    <div className="icon"><em className="fa-solid fa-right-to-bracket"></em></div>
                    {translate('Sign Out', langObj)}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </nav>

      {/* Sidenav */}
      {currentPath.indexOf('/intelligence') < 0? (
        <nav className={`sidenav ${sidenavActive? 'active': ''}`}>
          <ul className="wrapper">
            {menu.map((d, i) => (
              <div key={`menu_${i}`} 
                className={`menu-set ${menuToggle[i] 
                  || (d.indexMin <= props.activeIndex && props.activeIndex <= d.indexMax)? 'active': ''}`} 
              >
                {d.to? (
                  <Link className="menu-header" to={d.to}>
                    {d.title}
                  </Link>
                ): (
                  <div className="menu-header" onClick={e => onMenuToggle(e, i)}>
                    {d.title}
                    {d.children?.length? (
                      <div className="chev"><em className="fa-solid fa-chevron-right"></em></div>
                    ): (<></>)}
                  </div>
                )}
                {d.children?.length? (
                  <div className="menu-container">
                    {d.children.map((k, j) => (
                      <Link key={`submenu_${i}_${j}`} to={k.to} 
                        className={`menu ${props.activeIndex===k.index? 'active': ''}`} 
                      >
                        <div className="icon"><em className={k.icon}></em></div>
                        <span className="label">{k.title}</span>
                      </Link>
                      ))}
                  </div>
                ): (<></>)}
              </div>
            ))}
          </ul>
        </nav>
      ): (<></>)}

      {/* Theme */}
      {settings['APP_ENABLE_THEME'] === '1' && props.themes?.length? (
        <Dialog open={themeProcess? true: false} onClose={() => onThemeToggle()} 
          fullWidth={true} maxWidth="sm" scroll="paper" 
          PaperProps={{ component: 'form', onSubmit: onThemeUpdate }} 
        >
          <DialogTitle component="div" className="p-0">
            <div className="dialog-header">
              <h6 className="fw-600 lh-xs">{translate('Theme Settings', langObj)}</h6>
              <div className="btn-close" onClick={onThemeToggle}>
                <div className="hamburger active">
                  <div></div><div></div><div></div>
                </div>
              </div>
            </div>
          </DialogTitle>
          <DialogContent dividers={true} className="with-grids">
            <div className="grids">
              <div className="grid sm-100">
                <p>{translate('Theme', langObj)} <span className="color-danger">*</span></p>
                <div className="mt-1">
                  <Swiper spaceBetween={12} slidesPerView={1.5} 
                    breakpoints={{
                      768: { slidesPerView: 3 },
                      576: { slidesPerView: 2.5 },
                    }} 
                  >
                    {props.themes.map((d, i) => (
                      <SwiperSlide key={`theme_${i}`}>
                        <div className={`a c-pointer ${theme.value.theme !== d.value? 'op-20': ''}`} 
                          onClick={e => { e?.preventDefault(); onThemeChage('theme', d.value); }} 
                        >
                          <div className="ss-img horizontal-02 no-hover bradius border-1 bcolor-fgray">
                            <div className="img-bg" 
                              style={{ backgroundImage: `url('${d?.image?.path || '/assets/img/default/img.jpg'}')` }} 
                            ></div>
                          </div>
                          <p className="xs text-center mt-1">{d.name}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              {props.themes.find(d => d.value === theme.value.theme)? (
                <div className="grid sm-100">
                  <p>{translate('Color', langObj)} <span className="color-danger">*</span></p>
                  <div className="mt-1">
                    <Swiper 
                      spaceBetween={12} slidesPerView={1.5} 
                      breakpoints={{
                        768: { slidesPerView: 3 },
                        576: { slidesPerView: 2.5 },
                      }} 
                    >
                      {props.themes.find(d => d.value === theme.value.theme).colors.map((d, i) => (
                        <SwiperSlide key={`color_${i}`}>
                          <div className={`a c-pointer ${theme.value.color !== d.value? 'op-20': ''}`} 
                            onClick={e => { e?.preventDefault(); onThemeChage('color', d.value); }} 
                          >
                            <div className="ss-img no-hover bradius border-1 bcolor-fgray">
                              <div className="img-bg" 
                                style={{ backgroundImage: `url('${d?.image?.path ||'/assets/img/default/img.jpg'}')` }} 
                              ></div>
                            </div>
                            <p className="xs text-center mt-1">{d.name}</p>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              ): (<></>)}
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btns mt-0">
              <button type="submit" className="btn btn-action btn-p">
                {translate('Save', langObj)}
              </button>
              <button onClick={onThemeToggle} 
                type="button" className="btn btn-action btn-default" 
              >
                {translate('Close', langObj)}
              </button>
            </div>
          </DialogActions>
        </Dialog>
      ): (<></>)}
    </>): (<></>)
  );
}

Topnav.defaultProps = {};
Topnav.propTypes = {
  processSignout: PropTypes.func.isRequired,
  userRead: PropTypes.func.isRequired,
  userUpdate: PropTypes.func.isRequired,
  feProcessList: PropTypes.func.isRequired,
  smProcessList: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  theme: state.app.theme,
  themes: state.app.themes,
  currencies: state.app.currencies,
  useCurrency: state.app.useCurrency,
  activeIndex: state.app.sidenavActiveIndex,
});
export default connect(mapStateToProps, {
  processSignout: userSignout,
  userRead: userRead,
  userUpdate: userUpdate,
  feProcessList: feProcessList,
  smProcessList: smProcessList,
})(Topnav);